import { useEffect, useState } from 'react';

/** Operator logo from the admin; falls back to a coloured circle with the operator's first letter. */
export default function OperatorLogo({ src, name, accent = '#1E9BD9', className = 'w-8 h-8', letterClass = 'text-sm', testId }) {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [src]);

  if (src && !failed) {
    return <img src={src} alt={name || ''} className={`${className} object-contain shrink-0`} onError={() => setFailed(true)} data-testid={testId} />;
  }
  return (
    <span
      className={`${className} ${letterClass} shrink-0 inline-flex items-center justify-center rounded-full font-black text-white leading-none select-none`}
      style={{ background: accent }}
      aria-label={name || ''}
      data-testid={testId ? `${testId}-fallback` : undefined}
    >
      {(name || '?').trim().charAt(0).toUpperCase()}
    </span>
  );
}
